import { QualityLevel } from './QualityProfiles';

const STORAGE_KEY = 'sfx.graphicsSettings.v1';

export interface GraphicsSettings {
  /** `null` means "let capability detection (or `?quality=`) decide". */
  qualityLevel: Exclude<QualityLevel, 'custom'> | null;
  renderScale: number;
  terrainSelfShadow: boolean;
  eclipseShadows: boolean;
  vegetationEnabled: boolean;
}

const DEFAULTS: GraphicsSettings = {
  qualityLevel: null,
  renderScale: 1,
  terrainSelfShadow: true,
  eclipseShadows: true,
  vegetationEnabled: true,
};

/**
 * Reads saved graphics settings. Storage can be unavailable (private
 * browsing, disabled by policy) or hold a malformed or older blob; either
 * way, falling back to defaults is preferable to failing to start.
 */
export function loadGraphicsSettings(): GraphicsSettings {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULTS };
    const parsed = JSON.parse(raw) as Partial<GraphicsSettings>;
    return {
      qualityLevel: parsed.qualityLevel ?? DEFAULTS.qualityLevel,
      renderScale: typeof parsed.renderScale === 'number' ? parsed.renderScale : DEFAULTS.renderScale,
      terrainSelfShadow:
        typeof parsed.terrainSelfShadow === 'boolean' ? parsed.terrainSelfShadow : DEFAULTS.terrainSelfShadow,
      eclipseShadows:
        typeof parsed.eclipseShadows === 'boolean' ? parsed.eclipseShadows : DEFAULTS.eclipseShadows,
      vegetationEnabled:
        typeof parsed.vegetationEnabled === 'boolean' ? parsed.vegetationEnabled : DEFAULTS.vegetationEnabled,
    };
  } catch (err) {
    console.warn('[GraphicsSettings] failed to read saved settings', err);
    return { ...DEFAULTS };
  }
}

export function saveGraphicsSettings(settings: GraphicsSettings): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch (err) {
    console.warn('[GraphicsSettings] failed to save settings', err);
  }
}
